import { I18n } from '@byted-cg/linkchat-plugin';
import React from 'react';
import { IMessage } from '@byted-cg/linkchat-core';
import { inject, observer } from 'mobx-react';
import { AppContextType } from '../../../linkchat/src/lib/type';
import { Avatar } from '@byted-cg/linkchat-ui';
import LazyComponent from './LazyComponent';

import MessageWrapper from '../../../../src/pages/chat/components/MessageWrapper';
import { useMemo } from 'react';
import { SEND_TYPE } from '../../../linkchat/src/constants/status';
import { MESSAGE_ALL_TYPE } from '../../../../src/pages/chat/constants';
interface MessageReplyProps {
  appContext: AppContextType;
  message: IMessage & {
    ext: {
      [k: string]: any;
    };
    createdAt: number | string;
  };
  index?: Number;
}

const parseSystemTime = (timestamp: number | string) => {
  const oneDayTimeStamp = 24 * 60 * 60 * 1000;
  const now = Date.now();
  const t = new Date(timestamp);
  const year = t.getFullYear();
  const month = t.getMonth();
  const day = t.getDate();
  const hour = t.getHours();
  const minute = t.getMinutes();

  const addZero = (num: number) => (num > 9 ? num : `0${num}`);

  // That day
  if (now - timestamp < oneDayTimeStamp) {
    return `${addZero(hour)}:${addZero(minute)}`;
    // Yesterday
  } else {
    return `${addZero(month + 1)}-${addZero(day)} ${addZero(hour)}:${addZero(
      minute,
    )}`;
  }
};

const MessageReply: React.FC<MessageReplyProps> = ({
  appContext,
  message,
  index,
}) => {
  const isFromMe = message?.ext?.senderType === SEND_TYPE.USER;
  try {
    if (
      Number(message.type) === MESSAGE_ALL_TYPE.JARVIS_TYPE &&
      message.content
    ) {
      const content = JSON.parse(message.content);
      const {
        componentMeta: componentMetaStr = '{}',
        componentConfig: componentConfigStr = '{}',
      } = content;

      const componentConfig = JSON.parse(componentConfigStr) || {};
      const componentMeta = JSON.parse(componentMetaStr) || {};
      const { name, version } = componentMeta;
      const info = name?.replace?.(/@/g, '');
      const assetsPrefix = '//sf1-cdn-tos.toutiaostatic.com/obj/unpkg';

      message.component = {
        code: componentMeta.componentCode,
        version,
        isRemote: true,
        meta: componentMeta,
        config: componentConfig,
        component: {
          js: `${assetsPrefix}/${info}/${version}/lib/index.js`,
          css: `${assetsPrefix}/${info}/${version}/lib/index.css`,
        },
      };

      // 机器人问答 - 答案卡片
      if (
        componentMeta.componentCode === 'jarvis-component-auto-answer-react'
      ) {
        message.component.code = 'jarvis-component-auto-answer-react';
        message.component.version = '';
        message.component.isRemote = false;
        message.expansion = (message.expansion || []).filter(
          (item) => item.code !== 'thumbs-up-down',
        );
        message.expansion.push({
          code: 'thumbs-up-down',
          version: '',
          meta: {},
          config: {
            transferAfterHate: componentConfig.transferAfterHate,
          },
        });
      }

      if (message?.ext?.jarvis_data) {
        try {
          message.jarvisData = JSON.parse(message?.ext?.jarvis_data);
        } catch (error) {
          message.jarvisData = {};
        }
      }

      try {
        const cdn = JSON.parse(content?.cdn);
        message.component.component = window.$isOversea
          ? {
              js: `//${cdn.sg.js}`,
              css: `//${cdn.sg.css}`,
            }
          : {
              js: `//${cdn.cn.js}`,
              css: `//${cdn.cn.css}`,
            };
      } catch (e) {
        console.log('e---', e);
        message.hide = true;
      }
    }
  } catch (error) {
    message.hide = true;
    console.warn(error);
  }
  const MessageAvatar = useMemo(() => {
    const { avatarType = 'key' } = message.user || {};
    if (appContext?.renderConfig?.hideAvatar) return null;
    let avatarsConfig = appContext?.renderConfig?.avatars;
    let avatar = isFromMe ? 'sender' : 'revicer';
    switch (avatarType) {
      case 'key':
        return avatarsConfig && avatarsConfig[avatar as string] ? (
          <Avatar
            src={avatarsConfig[avatar as string] as string}
            className="avatarSpanReply"
          />
        ) : null;
      case 'url':
        return (
          <Avatar
            src={avatar as string}
            className="avatarSpanReply"
            style={{
              width: '24px',
            }}
          />
        );
      default:
        return (
          <LazyComponent
            className="avatarSpanReply"
            message={message}
            config={avatar as IComponent}
          />
        );
    }
  }, []);

  return (
    <div className="replyContainer">
      <div className="emptyMask"></div>
      <div className="avatarNameTime">
        {MessageAvatar}
        <div className="messageName">
          {isFromMe ? I18n.t('i', {}, '我') : '【客服】'}
        </div>
        <div className="messageTime">
          {parseSystemTime(message.createdAt as string)}
        </div>
      </div>
      <div className="messageWrapper">
        {Number(message.type) === MESSAGE_ALL_TYPE.JARVIS_TYPE &&
        message.component ? (
          <LazyComponent
            appContext={appContext}
            config={message.component}
            message={message}
          />
        ) : message?.ext?.['s:invisible'] ? (
          <div style={{ color: '#999' }}>
            {I18n.t('you_deleted_a_message', {}, '你删除了一条消息')}
          </div>
        ) : (
          <MessageWrapper appContext={appContext} message={message} />
        )}
      </div>
      {index === 0 && <div className="line"></div>}
    </div>
  );
};

export default inject<{
  appContext: AppContextType;
}>(({ appContext }) => ({
  appContext,
}))(observer(MessageReply));
